export const IMAGES = {
  heroField:
    "https://images.unsplash.com/photo-1535379453347-1ffd615e2e08?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMGZhcm0lMjBmaWVsZCUyMGhhcnZlc3R8ZW58MHx8fHwxNzgzNDgyMTU3fDA&ixlib=rb-4.1.0&q=70&w=1600",
  milletProcessing:
    "https://images.pexels.com/photos/2965707/pexels-photo-2965707.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=700&w=560",
  milletFeed:
    "https://images.pexels.com/photos/11519186/pexels-photo-11519186.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=700&w=560",
  wheatGrain: "/products/wheat.webp",
  seedsMacro: "/products/sesbania-seed.webp",
  harvestMacro:
    "https://images.pexels.com/photos/16977456/pexels-photo-16977456.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=600&w=800",
  wheatField:
    "https://images.unsplash.com/photo-1483871788521-4f224a86e166?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxhZ3JpY3VsdHVyZSUyMGZhcm0lMjBmaWVsZCUyMGhhcnZlc3R8ZW58MHx8fHwxNzgzNDgyMTU3fDA&ixlib=rb-4.1.0&q=70&w=1200",
  logistics:
    "https://images.unsplash.com/photo-1613690399151-65ea69478674?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMHNoaXAlMjBleHBvcnQlMjBsb2dpc3RpY3MlMjBjb250YWluZXJ8ZW58MHx8fHwxNzgyNTUyMzQ5fDA&ixlib=rb-4.1.0&q=70&w=1200",
};

const EXPORT_MARKETS = ["Middle East (UAE, Saudi Arabia, Oman)", "Europe", "Southeast Asia", "Africa", "North America"];

export const PRODUCTS = [
  {
    slug: "machine-clean-millet",
    name: "Machine Clean Millet",
    tagline: "Export Grade · Food Processing",
    image: IMAGES.milletProcessing,
    imageAlt: "Machine cleaned export-grade millet grain at SDRC Global processing facility",
    short:
      "Premium quality machine-cleaned millet suitable for food processing, flour mills, wholesalers, and export buyers.",
    description:
      "Our flagship machine-cleaned millet is sorted, de-stoned and polished to meet stringent international food-grade standards. Cleaned on precision gravity separators and optical sorters, every consignment is uniform in colour, size and purity — ready for milling, packaging and direct human consumption.",
    seoTitle: "Machine Clean Millet Supplier & Exporter India",
    seoDescription:
      "Buy premium machine clean millet from SDRC Global — export-grade, de-stoned and graded Indian millet for flour mills, food processing and international B2B buyers. MOQ 25 MT.",
    keywords:
      "Machine Clean Millet Supplier, Millet Exporter India, Bulk Millet Supplier, Green Millet Supplier, Indian Millet Export Company",
    applications: [
      "Flour mills & multigrain blends",
      "Food processing & ready-to-cook brands",
      "Wholesale & retail distribution",
      "International export buyers",
    ],
    grades: ["Premium Export Grade", "Standard Food Grade"],
    packaging: ["10 kg bags", "25 kg PP bags", "50 kg PP bags", "Others on request"],
    exportMarkets: EXPORT_MARKETS,
    specs: {
      Purity: "99% min",
      Moisture: "11% max",
      "Foreign Matter": "0.5% max",
      Admixture: "1% max",
      "Broken Grains": "1% max",
      Origin: "Rajasthan",
      "Shelf Life": "24 months",
      "Minimum Order Quantity": "25 MT",
    },
    faqs: [
      { q: "What is the minimum order quantity for machine clean millet?", a: "Our minimum order quantity is 25 MT (approximately one full container load). Larger recurring volumes are welcome." },
      { q: "What packaging options are available?", a: "We offer 10 kg, 25 kg and 50 kg PP bags, plus custom and jumbo bag packaging on request, with private-label options for bulk buyers." },
      { q: "Which countries do you export machine clean millet to?", a: "We export to the Middle East, Europe, Southeast Asia, Africa and North America, with full export documentation and quality certification." },
      { q: "What is the shelf life of your machine clean millet?", a: "Under proper dry, pest-controlled storage, our machine clean millet has a shelf life of up to 24 months." },
    ],
  },
  {
    slug: "bajra-pearl-millet",
    name: "Bajra (Pearl Millet)",
    tagline: "Export Grade · Nutri-Cereal",
    image: IMAGES.milletFeed,
    imageAlt: "Premium bajra pearl millet grain in a basket, export quality from SDRC Global",
    short:
      "High-quality bajra (pearl millet) — a gluten-free nutri-cereal for food, flour and export applications.",
    description:
      "Bajra, or pearl millet, is a nutrient-dense, gluten-free grain in strong demand worldwide. Our bajra is machine cleaned, graded and quality inspected for uniform colour and purity — suited to milling, health-food brands and international buyers.",
    seoTitle: "Bajra (Pearl Millet) Exporter & Supplier India",
    seoDescription:
      "SDRC Global is a trusted bajra (pearl millet) exporter from India — gluten-free, machine-cleaned, export-grade pearl millet for flour, health foods and bulk international buyers. MOQ 25 MT.",
    keywords:
      "Pearl Millet Exporter India, Bajra Exporter India, Bulk Pearl Millet Supplier, Pearl Millet Manufacturer India, Green Millet Supplier",
    applications: [
      "Bajra flour & health foods",
      "Multigrain & cereal blends",
      "Food manufacturers",
      "International export buyers",
    ],
    grades: ["Premium Export Grade", "Standard Grade"],
    packaging: ["10 kg bags", "25 kg PP bags", "50 kg PP bags", "Others on request"],
    exportMarkets: EXPORT_MARKETS,
    specs: {
      Purity: "99% min",
      Moisture: "11% max",
      "Foreign Matter": "0.5% max",
      Admixture: "1% max",
      "Broken Grains": "1% max",
      Origin: "Rajasthan",
      "Shelf Life": "24 months",
      "Minimum Order Quantity": "25 MT",
    },
    faqs: [
      { q: "Is bajra the same as pearl millet?", a: "Yes. Bajra is the Indian name for pearl millet — a gluten-free, nutrient-dense cereal grain widely used in flours, health foods and multigrain blends." },
      { q: "What is the minimum order quantity for bajra?", a: "The minimum order quantity is 25 MT (about one container load). We support large, recurring export orders." },
      { q: "Is your pearl millet gluten-free and export-grade?", a: "Yes. Our bajra is naturally gluten-free, machine cleaned to 99% purity, and prepared to export-grade standards with full documentation." },
      { q: "Which regions is your bajra sourced from?", a: "Our bajra is sourced from Rajasthan, one of India's premier pearl millet growing regions, ensuring consistent quality and supply." },
    ],
  },
  {
    slug: "wheat",
    name: "Wheat",
    tagline: "Food Grade · Milling",
    image: IMAGES.wheatGrain,
    imageAlt: "Golden Indian milling wheat grain being handled in the field, exported by SDRC Global",
    short:
      "Premium Indian wheat with high protein content, ideal for flour milling, food processing and export.",
    description:
      "Sourced from India's fertile grain belt, our wheat offers consistent grain size, strong gluten strength and clean, uniform quality. Machine cleaned and graded for milling, baking and bulk export requirements.",
    seoTitle: "Indian Wheat Exporter & Bulk Supplier",
    seoDescription:
      "Export-quality Indian wheat from SDRC Global — high-protein milling wheat, machine cleaned and graded for flour mills, bakeries and bulk international buyers. MOQ 25 MT.",
    keywords:
      "Wheat Exporter India, Indian Wheat Supplier, Bulk Wheat Supplier, Milling Wheat Exporter, Agricultural Commodity Exporter",
    applications: [
      "Flour mills (atta / maida / suji)",
      "Bakery & food processing",
      "Wholesale distribution",
      "Bulk export buyers",
    ],
    grades: ["Milling Grade", "Standard Grade"],
    packaging: ["10 kg bags", "25 kg bags", "50 kg bags", "Others on request"],
    exportMarkets: EXPORT_MARKETS,
    specs: {
      Purity: "99% min",
      Moisture: "10% max",
      "Foreign Matter": "1% max",
      Admixture: "2% max",
      "Broken Grains": "2% max",
      Origin: "Rajasthan",
      "Shelf Life": "10 months",
      "Minimum Order Quantity": "25 MT",
    },
    faqs: [
      { q: "What type of wheat does SDRC Global export?", a: "We export high-protein Indian milling wheat suitable for atta, maida and suji, as well as bakery and food-processing applications." },
      { q: "What is the minimum order quantity for wheat?", a: "Our minimum order quantity is 25 MT, with support for bulk and recurring container-load shipments." },
      { q: "How is the wheat packed for export?", a: "Wheat is supplied in 10 kg, 25 kg and 50 kg bags, with jumbo bags and custom packaging available on request." },
    ],
  },
  {
    slug: "sesbania-seed",
    name: "Sesbania Seed",
    tagline: "Green Manure · Fodder Seed",
    image: IMAGES.seedsMacro,
    imageAlt: "Sesbania (dhaincha) seed being bagged in a green field, supplied by SDRC Global",
    short:
      "Quality Sesbania (Dhaincha) seed for green manuring, soil enrichment and fodder cultivation.",
    description:
      "Sesbania (Dhaincha) seed is widely used as a fast-growing green-manure and nitrogen-fixing cover crop, as well as for fodder. Our seed is cleaned and graded for high germination and purity, serving agricultural distributors and bulk buyers.",
    seoTitle: "Sesbania (Dhaincha) Seed Supplier & Exporter India",
    seoDescription:
      "SDRC Global supplies quality Sesbania (Dhaincha) seed — high-germination green-manure and fodder seed for agricultural distributors and bulk international buyers. MOQ 25 MT.",
    keywords:
      "Sesbania Seed Supplier, Dhaincha Seed Exporter India, Green Manure Seed Supplier, Fodder Seed Exporter, Agricultural Commodity Exporter",
    applications: [
      "Green manuring & soil enrichment",
      "Nitrogen-fixing cover crop",
      "Fodder cultivation",
      "Agri distributors & bulk buyers",
    ],
    grades: ["Standard Grade", "FAQ"],
    packaging: ["10 kg bags", "25 kg bags", "50 kg bags", "Others on request"],
    exportMarkets: EXPORT_MARKETS,
    specs: {
      Purity: "99% min",
      Moisture: "10% max",
      "Foreign Matter": "1% max",
      Admixture: "2% max",
      "Broken Grains": "2% max",
      Origin: "Rajasthan",
      "Shelf Life": "10 months",
      "Minimum Order Quantity": "25 MT",
    },
    faqs: [
      { q: "What is Sesbania (Dhaincha) seed used for?", a: "Sesbania (Dhaincha) is a fast-growing, nitrogen-fixing green-manure and cover crop used for soil enrichment, and also cultivated for fodder." },
      { q: "What germination and purity can I expect?", a: "Our sesbania seed is cleaned and graded for high germination and 99% purity, ideal for reliable field establishment." },
      { q: "What is the minimum order quantity for sesbania seed?", a: "The minimum order quantity is 25 MT, with bulk supply available for distributors and large agricultural buyers." },
    ],
  },
];

export const PRODUCTS_BY_SLUG = PRODUCTS.reduce((acc, p) => {
  acc[p.slug] = p;
  return acc;
}, {});

export const SPEC_ORDER = [
  "Purity",
  "Moisture",
  "Foreign Matter",
  "Admixture",
  "Broken Grains",
  "Origin",
  "Shelf Life",
  "Minimum Order Quantity",
];
